/**
 * reggoraConstants.js
 *
 * Shared constants for Reggora order status badges, event display, etc.
 */

// ─── Order Status → Badge color mapping ───
// Colors reference MUI palette names or hex values
export const REGGORA_STATUS_COLORS = {
  "Finding Appraisers": "warning", // yellow
  Accepted: "info", // blue
  "Inspection Scheduled": "info", // indigo-ish
  "Inspection Completed": "success", // green
  "Under Review": "secondary", // purple
  Submitted: "success", // green (terminal)
  "On Hold": "warning", // amber
  Canceled: "error", // red (terminal)
  "Waiting for Payment": "warning",
  "Revision Requested": "warning",
  "Revision Submitted": "info",
};

// Terminal statuses — no further action possible
export const REGGORA_TERMINAL_STATUSES = ["Submitted", "Canceled"];

// ─── Webhook Event Type → Display config ───
export const REGGORA_EVENT_DISPLAY = {
  order_created: {
    label: "Order Created",
    icon: "AddCircleOutline",
    color: "info",
  },
  status_update: {
    label: "Status Update",
    icon: "UpdateOutlined",
    color: "default",
  },
  consumer_payment_created: {
    label: "Payment Requested",
    icon: "PaymentOutlined",
    color: "warning",
  },
  consumer_payment_completed: {
    label: "Payment Completed",
    icon: "PaidOutlined",
    color: "success",
  },
  order_report_received: {
    label: "Report Received",
    icon: "DescriptionOutlined",
    color: "info",
  },
  order_ready_for_review: {
    label: "Ready for Review",
    icon: "RateReviewOutlined",
    color: "secondary",
  },
  order_approved: {
    label: "Approved",
    icon: "CheckCircleOutline",
    color: "success",
  },
  order_report_sent: {
    label: "Report Sent",
    icon: "SendOutlined",
    color: "default",
  },
  order_updated: {
    label: "Order Updated",
    icon: "EditOutlined",
    color: "default",
  },
};

// ─── Webhook simulator presets (dev-only) ───
export const WEBHOOK_SIMULATOR_EVENTS = [
  {
    eventType: "order_created",
    label: "Order Created",
    status: "Finding Appraisers",
  },
  {
    eventType: "status_update",
    label: "Status → Accepted",
    status: "Accepted",
  },
  {
    eventType: "status_update",
    label: "Status → Inspection Scheduled",
    status: "Inspection Scheduled",
    eventData: {
      inspection_date: new Date(Date.now() + 7 * 86400000).toISOString(),
    },
  },
  {
    eventType: "status_update",
    label: "Status → Inspection Completed",
    status: "Inspection Completed",
  },
  {
    eventType: "status_update",
    label: "Status → Under Review",
    status: "Under Review",
  },
  {
    eventType: "status_update",
    label: "Status → Submitted",
    status: "Submitted",
  },
  {
    eventType: "consumer_payment_created",
    label: "Payment Created",
    status: null,
    eventData: { amount: 500, payment_id: "pay-test-001" },
  },
  {
    eventType: "consumer_payment_completed",
    label: "Payment Completed",
    status: null,
    eventData: { amount: 500, payment_id: "pay-test-001" },
  },
  {
    eventType: "order_report_received",
    label: "Report Received",
    status: null,
    eventData: { submission_version: 1 },
  },
  {
    eventType: "order_ready_for_review",
    label: "Ready for Review",
    status: null,
  },
  { eventType: "order_approved", label: "Approved", status: null },
  { eventType: "status_update", label: "Status → On Hold", status: "On Hold" },
  {
    eventType: "status_update",
    label: "Status → Canceled",
    status: "Canceled",
  },
];
